import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const providerRoutes: CustomRouteRecordRaw = {
  path: 'provider',
  name: 'provider',
  component: EmptyLayout,
  meta: {
    title: '供应商管理',
    iconfont: 'icon-store-2-line',
    requiredPermission: 'provider',
  },
  children: [
    {
      path: 'provider-list',
      name: 'providerList',
      component: () => import('@/views/provider/provider-list.vue'),
      meta: {
        title: '供应商列表',
        requiredPermission: 'provider.list',
      },
    },
    {
      path: 'service-item-list',
      name: 'serviceItemList',
      component: () => import('@/views/provider/service-item-list.vue'),
      meta: {
        title: '服务项目列表',
        requiredPermission: 'provider.service.item.list',
      },
    },
  ],
}